// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/umweltpakt-bayern/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const umweltpaktBayernDE: PageEntry = {
  id: "post.umweltpakt-bayern",
  locale: "de",
  slug: "umweltpakt-bayern",
  seo: {
    title: "Umweltpakt Bayern | Dietz GmbH",
    description: "Umweltpakt Bayern",
  },
  type: "post",
  h1: "Umweltpakt Bayern",
  blocks: [
    { kind: "heading", level: 2, text: "Umweltpakt Bayern" },
    { kind: "paragraph", text: "DIETZ ist Mitglied im Umweltpakt Bayern – eine Kooperation der Bayrischen Staatsregierung und der bayrischen Wirtschaft. Damit haben wir einen schnellen Zugang zu praxisnahen Informationen rund um den betrieblichen Umweltschutz und können an Projekten teilnehmen, die uns im Bereich Umwelt weiterbringen." }
  ],
};
